import { UseFormReturnType } from '@mantine/form';
import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router';
import { FormValuesType } from 'src/UI/dynamicUI/types';

// Defaults the joint-ownership toggle from the owner-selection step: two or more
// selected owners arrive as `joint=true`, a single owner as `joint=false`. Only
// applied on create so editing an existing item never has its value overwritten.
export function useJointOwnerDefault(
  form: UseFormReturnType<FormValuesType>,
  product: string,
  isCreateMode: boolean,
) {
  const [searchParams] = useSearchParams();
  // `useForm` hands out a fresh object each render, so an unguarded effect re-runs on every
  // one. Re-seeding the default each time would overwrite the switch as fast as the adviser
  // could turn it on, and the item would save as non-joint with its owners dropped. The
  // default is a starting point, so it is applied once and the form owns the value after.
  const seeded = useRef(false);

  useEffect(() => {
    if (seeded.current || !isCreateMode) {
      return;
    }
    const joint = searchParams.get('joint');
    if (joint === null) {
      return;
    }
    seeded.current = true;
    form.setFieldValue(`${product}.is_joint`, joint === 'true' ? 'true' : 'false');
  }, [searchParams, isCreateMode, product, form]);
}
